<template>
  <b-container fluid class="h-100">
    <!-- <b-card no-body class='overflow-hidden'> -->
      <b-row class="h-100">
        <b-col class="login-right text-center text-center d-none d-md-block">
          <b-container class="my-0 h-100 d-flex">
            <div class="row justify-content-center align-self-center w-100">
              <div>
              <div class="mb-4">
                <a href="https://www.vidon.ai">
                  <img src="@/assets/logo.png" height="64px"/>
                  <h1 class="no-decoration d-inline-block ml-2 title" style="position: relative; top: 12px; font-weight: 400;">Vidon</h1>
                </a>
                <p class="mt-4"><i>"The best prospecting I've seen in a long time"</i></p>
                <p>
                  <img src="@/assets/user.jpeg" class="b-avatar rounded-circle" width="32" height="32" />
                  Tom Simons, StageFour
                </p>
              </div>


              <p style="position: absolute; bottom: 20px; left: 20px;"><a href="https://www.vidon.ai">Back to homepage</a></p>
             <!-- <h2>5x Your email engagement</h2> -->
             </div>


            </div>
          </b-container>
        </b-col>

        <b-col class='text-center login-left'>
          <b-container class="my-0 h-100 d-flex">
            <div class="row justify-content-center align-self-center w-100">
              <div>
                <img src="@/assets/login.svg" width="264" class="mb-2"/>
                <router-view />
             </div>
            </div>
          </b-container>
        </b-col>
      </b-row>
    <!-- </b-card> -->
  </b-container>
</template>

<script>
export default {

}
</script>

<style scoped>

.card {
  max-width: 42em;
  margin: auto;
}

.container {
  margin-top: 8em;
}

.google-logo {
  /* background-color: #FFF; */
}

.google-button {
  /* border-color: #346DF2 !important;
  background-color: #346DF2 !important;
  color: #FFF !important; */
}

.login-left {
  padding: 52px;
}

.login-right {
  margin: 0px;
  background-color: #cedafb;
  /* background-image: url('https://uploads-ssl.webflow.com/5ff8ae66241ed3f042df81fa/60095518260d1bf25208592a_output-onlinepngtools%20(1).png'); */
  background-position: 0 0;
  background-size: cover;
}

</style>
